/* eslint-disable no-case-declarations */
import { REDUX_ACTIONS } from '../../shared/config/constants';
const initialState = {
  loading: false,
  data: [],
  errorMessage: '',
  paginatedElements: 0,
  activeState: 1
};
const payTargetsQuestionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REDUX_ACTIONS.PAY_TARGETS_QUESTIONS_LIST_LOADING:
      return {
        ...state,
        loading: true,
        errorMessage: ''
      };
    case REDUX_ACTIONS.PAY_TARGETS_QUESTIONS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [...action.payload.data],
        paginatedElements: action.payload.paginatedElements,
        errorMessage: ''
      };
    case REDUX_ACTIONS.PAY_TARGETS_QUESTIONS_LIST_ERROR:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload.message,
      };
    case REDUX_ACTIONS.PAY_TARGETS_QUESTIONS_RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};
export default payTargetsQuestionsReducer;
